import MessageType from '@/components/common/message-box/MessageType';
import Constant from '@/components/open/common/Constant';
import EventEmitter from '@/components/open/common/EventEmitter';

export default {
  ajaxErrorCallback(self) {
    return function(error) {
      error.stopPropagation();
      let infoMsg = error._response.errormsg || '网络异常，您可以稍后重试';
      if (error && error._response && error._response.status === 403) {
        infoMsg = '登录已过期，请重新登录';
        self.$alert(infoMsg, null, MessageType.INFO).then(() => {
          EventEmitter.fire(Constant.Events.SHOW_LOGIN);
        });
        return;
      }
      self.$alert(infoMsg, null, MessageType.FAIL);
    };
  },
  validateMail(rule, value, callback) {
    if (value == null || value.length < 1) {
      return callback(new Error('邮箱不能为空'));
    }
    value = value.replace('；', ';');
    if (/^;+$/.test(value)) {
      return callback(new Error('检测到错误的邮件地址'));
    }
    let temp = value.split(/[\n\s+；;]/g);
    let reg = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
    let validate = temp.every(item => {
      if (item !== '') {
        return reg.test(item);
      }
      return true;
    });
    if (!validate) {
      return callback(new Error('检测到错误的邮件地址'));
    };
    callback();
  },
  validateDemand(rule, value, callback) {
    if (value == null || value.length < 1) {
      return callback(new Error('续期需求不能为空'));
    }
    callback();
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/application/panels/js/ErrorHandler.js